import type { ReactNode } from 'react'
import { ThemeContext } from '../contexts/themeContext'
import { useThemeState } from './hooks'

/**
 * Провайдер темы приложения
 * Управляет состоянием темы на основе:
 * 1. Выбора пользователя (если залогинен)
 * 2. Системных настроек (если тема UNSPECIFIED)
 * 3. Темной темы по умолчанию
 */
export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const state = useThemeState()

  return (
    <ThemeContext.Provider value={state}>
      {children}
    </ThemeContext.Provider>
  )
}
